import React from "react";
import { Link } from "react-router-dom";

const TopCoupons = ({ tableData }) => {
  return (
    <>
      <p className="page-maintitle">Top Coupons</p>
      <div className="table-responsive-xl black-header">
        <table className="recentact-table mt-3 table ver-middle manage-vou-table">
          <thead>
            <tr>
              <th width="300px">Coupon Name</th>
              <th width="150px">Marketplace</th>
              <th>Coupon Code</th>
              <th>Downloaded Coupons</th>
              <th>Redeemed Coupons</th>
            </tr>
          </thead>
          <tbody>
            {tableData.coupons_details?.length > 0 ? (
              tableData.coupons_details?.map((item) => {
                return (
                  <tr>
                    <td
                      className="text-left text-limit-2 blue-underline-text"
                      title={item.coupon_name}
                    >
                      <Link>{item.coupon_name}</Link>
                    </td>
                    <td>
                      <p className="text-limit-2" title={item.market_place}>
                        {item.market_place}
                      </p>
                    </td>
                    <td>{item.coupon_code}</td>
                    <td>{item.downloaded_coupons}</td>
                    <td>{item.redeemed_coupons}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={9} className="text-center">
                  <p className="no-record">No records available!</p>
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={5} className="table-viewall">
                <Link to={"/my-account/manage-coupons"}>View All</Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TopCoupons;
